import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'
import 'slim-select/styles';

// Connects to data-controller="select"
export default class extends Controller {
  static values = {
    url: String,
    relatedField: String,
    relatedFieldName: String
  }

  connect () {
    new SlimSelect({
      select: this.element,
      settings: {
        placeholderText: 'bitte auswählen',
      },
      events: {
        beforeChange: (newValue, _) => {
          this.element.dataset.value = newValue[0].value
        },
        search: (search, _) => {
          return new Promise((resolve, _) => {
            const related_field = this.relatedFieldValue
            const related_field_name = this.relatedFieldNameValue

            let url = this.urlValue

            if (url.match(/\?/)) {
              url = url + '&'
            } else {
              url = url + '?'
            }

            if (related_field > '' && related_field_name > '') {
              let form_id = this.element.closest('form').id
              let value = document.querySelector(`#${form_id} ${related_field}`).value

              url = `${url}${related_field_name}=${value}&`
            }

            fetch(`${ url }search=${ search }`, {
              method: 'get',
              headers: {
                'Content-type': 'application/json'
              }
            })
              .then((response) => response.json())
              .then((data) => {
                resolve(data)
              })
          })
        }
      }
    })
  }
}
